import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ContactLogEntry } from "../../../domain/entities/pending-confirmation";
import { type PendingConfirmationDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listContactLogs = createAsyncThunk<
  ContactLogEntry[],
  string,
  { dispatch: PendingConfirmationDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_CONTACT_LOGS, async (requestId, { extra }) => {
  return await extra.contactCenterRepo.listContactLogs(requestId);
});
